import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database-deprecated';
import { Upload } from 'app/uploads/shared/upload';
import { Observable } from 'rxjs';
import { DateService } from 'app/date/date.service';
import { NotificationToastService } from 'app/notification/notification-toast.service';
import * as firebase from 'firebase/app';
import { SessionService } from 'app/sessions/session.service';
import { AngularFireAuth } from 'angularfire2/auth';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
@Component({
  selector: 'app-user-profile-page',
  templateUrl: './user-profile-page.component.html',
  styleUrls: ['./user-profile-page.component.css'],
  providers:[NotificationToastService, AngularFireDatabase, DateService]
})
export class UserProfilePageComponent implements OnInit {

  public userId:string;
  public imageToUpload = "assets/images/avatar-4.png";
  submitted : boolean = false;
  hasError : boolean ;
  selectedFiles: FileList;
  currentUpload: Upload;
  hasFile: Boolean = false;
  editProfile = true;
  editProfileIcon = 'icofont-edit';
  userData : Observable<any>;
  user: any;
  branches:any;
  passwordForm:FormGroup;
  userEmail:any;
  changePassword:any;
  err:any;
  constructor(public db:AngularFireDatabase, public af: AngularFireAuth, private nf:NotificationToastService) {
    this.userId = localStorage.getItem("courierapp_user_id");
   }

  ngOnInit() {
    this.initializeForm();
    this.getUser();
  }
  initializeForm()
  {
    let newPassword  = new FormControl('',Validators.required);
    this.passwordForm = new FormGroup({
      password: new FormControl('',Validators.required),
      newPassword: newPassword,
      confirmPassword: new FormControl('',[Validators.required,CustomValidators.equalTo(newPassword)])
    });
  }
  public getUser(){
    this.userData = this.db.object("users/"+this.userId);
    this.userData.subscribe(user=>{
      this.getBranchName(user.branch);
      this.user = user;
      if(user.imageUrl !=null)
      this.imageToUpload = user.imageUrl;
      this.userEmail = user.email;
    });
  }
  getBranchName(branchid)
  {
    if(branchid!=null)
    {
      firebase.database().ref("branches").child(branchid).once("value").then((branch)=>{
        this.user.branch = branch.child("name").val();
      });
    }
  }
  keyPressUserName(event)
  {
    var format = /[a-zA-Z0-9-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !format.test(inputChar)) {
      event.preventDefault();
    }
  }

  onChangePasswordg()
  {
    this.submitted = true;
    if(this.passwordForm.valid)
    {
      var user = this.af.auth.currentUser;
      user.updatePassword(this.passwordForm.value.password).then(()=>{
        alert("Password has been changed");
        this.submitted = false;
      }).catch((error) => {
        // An error happened.
        this.submitted = false;
        this.changePassword = false;
      });
    }
  }

  onChangePassword()
  {
    this.submitted = true;
    if(this.passwordForm.valid)
    {
      // Prompt the user to re-provide their sign-in credentials
    var userProvidedPassword = this.passwordForm.value.password;
    const credential = firebase.auth.EmailAuthProvider.credential(
      this.userEmail, 
      userProvidedPassword
    );
      var user = this.af.auth.currentUser;
      var newPassword = this.passwordForm.value.newPassword;
      user.reauthenticateWithCredential(credential).then(() => {
        // User re-authenticated.
        this.af.auth.currentUser.updatePassword(newPassword).then(()=>{
          this.submitted = false;
          this.changePassword = false;
          this.err = null;
          this.passwordForm.reset();
          //alert("Password has been changed");
          this.nf.addToast({title:'Success', msg:'Password has been changed', timeout: 5000, theme:'material', position:'bottom-right', type:'success'});
        }).catch((error) => {
          // An error happened.
          this.err = error;
        });
      }).catch((error) => {
        // An error happened.
        this.err = error;
      });
    }
  }
  
  methodChangePassword()
  {
    var user = this.af.auth.currentUser;
    this.af.auth.currentUser.updatePassword("secret").then(()=>{
      alert("Password has been changed");
    }).catch(function(error) {
      // An error happened.
    });


  }
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/layouts/user-profile-page/user-profile-page.component.ts